import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerAutocomplete = styled.div`
  & > div > div {
    margin: 10px 0px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 20px;
`

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
`
export const StyleButton = styled(Button)`
  margin-right: 15px;
`
